module.exports = __webpack_public_path__ + "img/zhanghao.2489d593.png";